import React, { useState } from 'react';
import api from '../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';

const EMPTY = { current: '', next: '', confirm: '' };

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  const close = (v) => { if (!v) { setForm(EMPTY); setError(''); } onOpenChange(v); };

  const submit = async () => {
    setError('');
    if (!form.current) return setError('Enter your current password');
    if (form.next.length < 6) return setError('New password must be at least 6 characters');
    if (form.next !== form.confirm) return setError('New passwords do not match');
    setSubmitting(true);
    try {
      await api.post('/auth/change-password', { current_password: form.current, new_password: form.next });
      toast.success('Password changed successfully');
      close(false);
    } catch (e) {
      setError(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Failed to change password');
    } finally { setSubmitting(false); }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-[#B89B72]" /> Change Password</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          <div><Label>Current Password</Label><Input type="password" value={form.current} onChange={set('current')} className="mt-1" data-testid="cp-current-input" /></div>
          <div><Label>New Password</Label><Input type="password" value={form.next} onChange={set('next')} placeholder="Minimum 6 characters" className="mt-1" data-testid="cp-new-input" /></div>
          <div><Label>Confirm New Password</Label><Input type="password" value={form.confirm} onChange={set('confirm')} className="mt-1" data-testid="cp-confirm-input" onKeyDown={e => e.key === 'Enter' && submit()} /></div>
          {error && <p className="text-sm text-rose-600" data-testid="cp-error">{error}</p>}
          <Button className="w-full bg-slate-900 hover:bg-slate-800" onClick={submit} disabled={submitting} data-testid="cp-submit">
            {submitting ? 'Saving...' : 'Update Password'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
